"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const syncAction_1 = __importDefault(require("@powerednow/shared/modules/syncAction"));
class Syncable {
    setSyncAction(syncAction) {
        // @ts-ignore
        this.data.sync_action = syncAction.toData();
    }
    resetSyncAction() {
        // @ts-ignore
        this.data.sync_action = null;
    }
    getSyncAction() {
        // @ts-ignore
        return this.data.sync_action && syncAction_1.default.fromData(this.data.sync_action);
    }
}
exports.default = Syncable;
//# sourceMappingURL=../../../src/mixin/syncable.js.map